import edm1 from '../assets/images/covers/EDM/1.jpg';
import edm2 from '../assets/images/covers/EDM/2.jpg';
import edm3 from '../assets/images/covers/EDM/3.jpg';
import edm7 from '../assets/images/covers/EDM/7.png';

import pop1 from '../assets/images/covers/POP/1.png';
import pop2 from '../assets/images/covers/POP/2.png';
import pop3 from '../assets/images/covers/POP/3.png';
import pop4 from '../assets/images/covers/POP/4.png';

import latin1 from '../assets/images/covers/LATIN/1.png';
import latin2 from '../assets/images/covers/LATIN/2.png';
import latin3 from '../assets/images/covers/LATIN/3.png';
import latin4 from '../assets/images/covers/LATIN/4.png';

import other1 from '../assets/images/covers/OTHERS/1.png';
import other3 from '../assets/images/covers/OTHERS/3.png';
import other4 from '../assets/images/covers/OTHERS/4.png';
import other8 from '../assets/images/covers/OTHERS/8.png';

import kids1 from '../assets/images/covers/KIDS/1.png';
import kids2 from '../assets/images/covers/KIDS/2.png';
import kids3 from '../assets/images/covers/KIDS/3.png';
import kids4 from '../assets/images/covers/KIDS/4.png';

import radio1 from '../assets/images/covers/RADIO/1.png';
import radio2 from '../assets/images/covers/RADIO/2.png';
import radio3 from '../assets/images/covers/RADIO/3.png';
import radio4 from '../assets/images/covers/RADIO/4.png';


const audioData = () => {
    const baseUrl = 'https://duf4rsrp3ahzy.cloudfront.net/'
    const edmSong1 =`${baseUrl}ALBUMS+COLLABS/EDM/1+Demons+JASONLO.mp3`;
    const edmSong2 = `${baseUrl}ALBUMS+COLLABS/EDM/2+Falling+Z3RG.mp3`;
    const edmSong3 = `${baseUrl}ALBUMS+COLLABS/EDM/3+Kevin+Sky+The+Real+World.mp3`;
    const edmSong7 = `${baseUrl}ALBUMS+COLLABS/EDM/7+TSOML.mp3`
    

    const popSong1 = `${baseUrl}ALBUMS+COLLABS/POP/1+How+I+feel.mp3`
    const popSong2 = `${baseUrl}ALBUMS+COLLABS/POP/2+Words+WonT+Show.mp3`
    const popSong3 = `${baseUrl}ALBUMS+COLLABS/POP/3+Music+Still+In+Me.mp3`
    const popSong4 = `${baseUrl}ALBUMS+COLLABS/POP/4+There+For+You.mp3`
   

    const latinSong1 = `${baseUrl}ALBUMS+COLLABS/LATIN/1+dance-monkey-spanish-cumbia-remix.mp3`
    const latinSong2 = `${baseUrl}ALBUMS+COLLABS/LATIN/2+Esta+Noche++ReverbVibes.mp3`
    const latinSong3 = `${baseUrl}ALBUMS+COLLABS/LATIN/3+Pheel+J+hablame+de+ti.mp3`
    const latinSong4 = `${baseUrl}ALBUMS+COLLABS/LATIN/4+BESAME.mp3`

    const othersSong1 = `${baseUrl}ALBUMS+COLLABS/ROCK+JAZZ+OTHERS/1+Madonna++Papa+Don't+Preach.mp3`
    const othersSong3 = `${baseUrl}ALBUMS+COLLABS/ROCK+JAZZ+OTHERS/3+School+of+Magic.mp3`
    const othersSong4 = `${baseUrl}ALBUMS+COLLABS/ROCK+JAZZ+OTHERS/4+MAMA.mp3`
    const othersSong8 = `${baseUrl}ALBUMS+COLLABS/ROCK+JAZZ+OTHERS/8.+Las+Chicas+Saben+Luchar++++Girls+Know+How+To+Fight+++++Spanish+Version+(128kbit_AAC).m4a`
    
    const kidsSong1 =`${baseUrl}ALBUMS+COLLABS/KID+SONGS/1+Who+stole+the+moon.mp3`;
    const kidsSong2 = `${baseUrl}ALBUMS+COLLABS/KID+SONGS/2+baby-shark-baby-shark-song-baby-shark-video-nursery-rhymes.mp3`;
    const kidsSong3 = `${baseUrl}ALBUMS+COLLABS/KID+SONGS/3+canciones-para-ninos-cancion-de-las-patinetas-canciones-infantiles-little-baby-bum-junior.mp3`;
    const kidsSong4 = `${baseUrl}ALBUMS+COLLABS/KID+SONGS/4+de+colores.mp3`
   

    const radioSong1 = `${baseUrl}ALBUMS+COLLABS/RADIO+JINGLES/1+Corina+Boats.mp3`
    const radioSong2 = `${baseUrl}ALBUMS+COLLABS/RADIO+JINGLES/2+Blue+Planet.mp3`
    const radioSong3 = `${baseUrl}ALBUMS+COLLABS/RADIO+JINGLES/3+Sun+Studio.mp3`
    const radioSong4 = `${baseUrl}ALBUMS+COLLABS/RADIO+JINGLES/4 Etiquetoc.mp3`



    
    return { 
      EdmDance :[
        {artist: 'JASONLO', title: 'Demons', url: edmSong1, filename: '1+Demons+JASONLO.mp3', language: 'Spanish', imgSrc: edm1, isPlaying: false},
        {artist: 'Z3RG & FUZE', title: 'Falling', url: edmSong2, filename: '2+Falling+Z3RG.mp3', language: 'Spanish', imgSrc: edm2, isPlaying: false},
        {artist: 'Kevin Sky', title: 'The real world', url: edmSong3, filename: '3+Kevin+Sky+The+Real+World.mp3', language: 'Spanish', imgSrc: edm3, isPlaying: false},
        {artist: '', title: 'TSOML', url: edmSong7, filename: '7+TSOML.mp3', language: 'Spanish', imgSrc: edm7, isPlaying: false}
      ],
      pop: [
        {artist: 'D47', title: 'How I Feel', url: popSong1, filename: '1+How+I+feel.mp3', language: 'Spanish', imgSrc: pop1, isPlaying: false},
        {artist: 'Brad Parsons', title: 'Words Won\'t Show', url: popSong2, filename: '2+Words+WonT+Show.mp3', language: 'Spanish', imgSrc: pop2, isPlaying: false},
        {artist: 'Brad Parsons', title: 'Music Still In Me', url: popSong3, filename: '3+Music+Still+In+Me.mp3', language: 'Spanish', imgSrc: pop3, isPlaying: false},
        {artist: 'Brad Parsons', title: 'There For You', url: popSong4, filename: '4+There+For+You.mp3', language: 'Spanish', imgSrc: pop4, isPlaying: false},
       

      ],
      latin: [
        {artist: 'DJ Gecko', title: 'Dance Monkey Spanish version', url: latinSong1, filename: '1+dance-monkey-spanish-cumbia-remix.mp3', language: 'Spanish', imgSrc: latin1, isPlaying: false},
        {artist: 'Reverb Vibes', title: 'Esta Noche', url: latinSong2, filename: '2+Esta+Noche++ReverbVibes.mp3', language: 'Spanish', imgSrc: latin2, isPlaying: false},
        {artist: 'Pheel J', title: 'Hablame De Ti', url: latinSong3, filename: '3+Pheel+J+hablame+de+ti.mp3', language: 'Spanish', imgSrc: latin3, isPlaying: false},
        {artist: '', title: 'Bésame', url: latinSong4, filename: '4+BESAME.mp3', language: 'Spanish', imgSrc: latin4, isPlaying: false},
      ],

      jazzRockOther: [
        {artist: 'Franck Choppin', title: 'Papa Don\'t Preach', url: othersSong1, filename: '1+Madonna++Papa+Don\'t+Preach.mp3', language: 'Spanish', imgSrc: other1, isPlaying: false},
        {artist: 'MC Jams', title: 'Lac Chicas Saben Luchar', url: othersSong8, filename: '8.+Las+Chicas+Saben+Luchar++++Girls+Know+How+To+Fight+++++Spanish+Version+(128kbit_AAC).m4a', language: 'Spanish', imgSrc: other8, isPlaying: false},
        {artist: '', title: 'School Of Magic', url: othersSong3, filename: '3+School+of+Magic.mp3', language: 'Spanish', imgSrc: other3, isPlaying: false},
        {artist: 'Ingrid Alcalde', title: 'Mama', url: othersSong4, filename: '4+MAMA.mp3', language: 'Spanish', imgSrc: other4, isPlaying: false},
      ],

      kidsSongs: [
        {artist: 'Yuri Mezenko', title: 'Who Stole The Moon', url: kidsSong1, filename: '1+Who+stole+the+moon.mp3', language: 'Spanish', imgSrc: kids1, isPlaying: false},
        {artist: 'Cartoon Studio', title: 'Baby Shark', url: kidsSong2, filename: '2+baby-shark-baby-shark-song-baby-shark-video-nursery-rhymes.mp3', language: 'Spanish', imgSrc: kids2, isPlaying: false},
        {artist: 'Little Baby Bum', title: 'Canión De Las Patinetas', url: kidsSong3, filename: '3+canciones-para-ninos-cancion-de-las-patinetas-canciones-infantiles-little-baby-bum-junior.mp3', language: 'Spanish', imgSrc: kids3, isPlaying: false},
        {artist: 'Rockalingua', title: 'De Colores', url: kidsSong4, filename: '4+de+colores.mp3', language: 'Spanish', imgSrc: kids4, isPlaying: false},
      ],

      radio: [
        {artist: 'Corina Boats Holiday', title: 'Corina Boats', url: radioSong1, filename: '1+Corina+Boats.mp3', language: 'Spanish', imgSrc: radio1, isPlaying: false},
        {artist: 'Blue Planet Aquarium', title: 'Blue Planet', url: radioSong2, filename: '2+Blue+Planet.mp3', language: 'Spanish', imgSrc: radio2, isPlaying: false},
        {artist: 'Sun Studio', title: 'Sun Studio', url: radioSong3, filename: '3+Sun+Studio.mp3', language: 'Spanish', imgSrc: radio3, isPlaying: false},
        {artist: 'Etiquetoc', title: 'Etiquetoc', url: radioSong4, filename: '4 Etiquetoc.mp3', language: 'Spanish', imgSrc: radio4, isPlaying: false},
      ]    
    }
  }
  
  export default audioData;